module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading.gif"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f21e8b5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/loading.vue
// module id = 558
// module chunks = 62